import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = { baseUrl: String }

  connect() {
    this.loading = false
  }

  switch(event) {
    event.preventDefault()
    if (this.loading) return

    const button = event.currentTarget
    const tab = button.dataset.profileTabsTabParam
    if (!tab) return

    const url = new URL(this.baseUrlValue, window.location.origin)
    url.searchParams.set("tab", tab)

    this.loading = true
    button.disabled = true

    fetch(url.toString(), {
      headers: { "X-Requested-With": "XMLHttpRequest" },
      credentials: "same-origin"
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.text()
      })
      .then(html => {
        this.contentTarget.innerHTML = html
        this.setActiveTab(button)
        history.replaceState({}, "", url.toString())
      })
      .catch(error => {
        console.error("[profile-tabs] Failed to load tab:", error)
      })
      .finally(() => {
        this.loading = false
        button.disabled = false
      })
  }

  setActiveTab(activeButton) {
    this.element.querySelectorAll("[data-profile-tabs-tab-param]").forEach(button => {
      const isActive = button === activeButton
      button.classList.toggle("text-[var(--color-primary)]", isActive)
      button.classList.toggle("border-b-2", isActive)
      button.classList.toggle("border-[var(--color-primary)]", isActive)
      button.classList.toggle("text-gray-500", !isActive)
      button.classList.toggle("hover:text-gray-700", !isActive)
    })
  }
}
